<script lang="ts">
  import { Button } from '$shared/components';

  interface Props {
    uploading?: boolean;
    disabled?: boolean;
    allowHeightInherit?: boolean;
    uploadingPercentage?: number;
    totalFiles?: number;
    completedFiles?: number;
    acceptOnly?: string | null | undefined;
    onupload?: (payload: File[]) => void;
  }

  let {
    uploading = false,
    disabled = false,
    allowHeightInherit = false,
    uploadingPercentage = 0,
    totalFiles = 0,
    completedFiles = 0,
    acceptOnly = undefined,
    onupload
  }: Props = $props();

  let isdragOver = $state(false);
  let fileInput: HTMLElement = $state();

  const dispatchUpload = (files: File[]): void => {
    onupload?.(Array.from(files));
  };

  const onDragOver = () => {
    isdragOver = true;
  };

  const onDragLeave = () => {
    isdragOver = false;
  };

  const onDrop = (e): void => {
    isdragOver = false;
    const data = e.dataTransfer.items;
    const files = [];
    for (let i = 0; i < data.length; i++) {
      files.push(data[i].getAsFile());
    }
    dispatchUpload(files);
  };

  const onClickUpload = () => {
    if (fileInput) {
      fileInput.click();
    }
  };

  const onFileInputChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    dispatchUpload(e.target.files);
  };
</script>

<div
  class="comp-uploader"
  ondrop={(e) => { e.preventDefault(); onDrop(e); }}
  ondragover={(e) => { e.preventDefault(); onDragOver(); }}
  ondragleave={(e) => { e.preventDefault(); onDragLeave(); }}
  class:isdragOver
  class:disabled
  class:height-inherit={allowHeightInherit}
>
  {#if uploading}
    {#if uploadingPercentage < 100}
      <div class="label">
        Completed uploading ({completedFiles}/{totalFiles})... <span>{uploadingPercentage}%</span>
      </div>
    {:else}
      <div class="label">Finishing upload. Please wait...</div>
    {/if}
  {:else}
    <div class="label">Drop file here or</div>
    <div class="upload-btn">
      <Button icon="icon-upload" name="upload" onclick={onClickUpload} {disabled}>Upload</Button>
    </div>
    <input
      data-cy="fileInput"
      bind:this={fileInput}
      type="file"
      multiple
      hidden
      accept={acceptOnly}
      onchange={onFileInputChange}
    />
  {/if}
</div>

<style>
  .comp-uploader {
    background-color: var(--grey-bg);
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 1px 2px 10px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }
  .comp-uploader .label {
    margin-right: 8px;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: var(--grey-medium);
  }
  .comp-uploader.isdragOver {
    background-color: #fff;
    border: 1px solid var(--blue);
  }
  .comp-uploader.disabled {
    pointer-events: none;
  }
  .comp-uploader.height-inherit {
    height: inherit;
  }
</style>
